module.exports = __webpack_public_path__ + "img/PDB-Thumbnail.363b8587.jpeg";